export { isFunction, isBrowser, isInShape } from './checks';
